<template>
  <v-container fluid>
    <v-progress-linear v-if="loading" indeterminate color="deep-purple" />
    <h2 class="deep-purple--text lighten-3 mb-4">{{ $t('adminActionLogs.title') }}</h2>
    <admin-action-logs-filter v-model="params" @search="search"></admin-action-logs-filter>
    <admin-action-logs-table
      :table-loading="loading"
      v-model="page"
      :items="logs"
      :length="totalPages"
      :has-filter="hasActiveFilter"
    ></admin-action-logs-table>
  </v-container>
</template>

<script>
import AdminActionLogsFilter from '@/components/adminActionLogs/AdminActionLogsFilter.vue';
import AdminActionLogsTable from '@/components/adminActionLogs/AdminActionLogsTable.vue';
import LoadingMixin from '@/mixins/loading';
import SnackbarMixin from '@/mixins/snackbar';
import adminActionLogService from '@/services/adminActionLog.service';

const emptyFilter = () => ({
  rowPk: '', tableName: '', actor: '', from: '', to: '',
});

export default {
  name: 'AdminActionLogs',
  components: { AdminActionLogsFilter, AdminActionLogsTable },
  mixins: [LoadingMixin, SnackbarMixin],
  data: () => ({
    page: 1,
    params: emptyFilter(),
    logs: [],
    totalPages: 1,
  }),
  computed: {
    hasActiveFilter() {
      return Object.values(this.params).some((value) => Boolean(value && value.trim()));
    },
  },
  methods: {
    async fetch() {
      if (!this.hasActiveFilter) {
        this.logs = [];
        this.totalPages = 1;
        return;
      }
      this.loader();
      try {
        const { data, totalPages } = await adminActionLogService.findAll(this.page, this.params);
        this.logs = data;
        this.totalPages = totalPages;
      } catch (error) {
        this.snackbarError(this.$t('error.error_on_save'));
      } finally {
        this.loader();
      }
    },
    search() {
      if (this.page !== 1) {
        this.page = 1;
        return;
      }
      this.fetch();
    },
  },
  watch: {
    page() {
      this.fetch();
    },
  },
};
</script>
